import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Loans } from 'src/app/Models/loan';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-loan',
  templateUrl: './loan.component.html',
  styleUrls: ['./loan.component.css']
})
export class LoanComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Loans;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Loans form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.YEAR_NAME == undefined || this.data.YEAR_NAME=="") {
      this.message.error("Please Enter Year Name" , "");
      isOk = false
    }
    if (this.data.AMOUNT == undefined || this.data.AMOUNT==0) {
      this.message.error("Please Enter Amount" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE == undefined || this.data.PERCENTAGE==0) {
      this.message.error("Please Enter Percentage" , "");
      isOk = false
    }
    if (this.data.PERCENTAGE_TOTAL == undefined || this.data.PERCENTAGE_TOTAL==0) {
      this.message.error("Please Enter Total Percentage" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No" , "");
      isOk = false
    }
    if(isOk){
    

    

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateLoans(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Loans information updated Successfully...", "");

	this.logtext = 'Update & Close - Loans form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Loans ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Loans form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Loans ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update loans information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createLoans(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Loans information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Loans form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Loans ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Loans();
	// this.logtext = 'Save & New - Loans form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Loans ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add loans information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Loans form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Loans ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}